"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleShareWithMyFavGroup = exports.getMyFavItems = void 0;
var arcgis_rest_portal_1 = require("@esri/arcgis-rest-portal");
var __1 = require("..");
// let favGroupId = '';
// let session:UserSession = null;
// export const setMyFavoriteGroup = ({
//     groupId,
//     userSession
// }: {
//     groupId: string;
//     userSession: UserSession;
// }):void => {
//     if(!groupId){
//         console.error('My Favorite group ID is required');
//         return;
//     }
//     if(!userSession){
//         console.error('user session is required');
//         return;
//     }
//     favGroupId = groupId;
//     session = userSession;
// };
var getMyFavItems = function () { return __awaiter(void 0, void 0, void 0, function () {
    var myFavGroupId, userSession, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                myFavGroupId = __1.defaultOptions.myFavGroupId, userSession = __1.defaultOptions.userSession;
                if (!userSession || !myFavGroupId) {
                    return [2 /*return*/, []];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, arcgis_rest_portal_1.searchGroupContent)({
                        groupId: myFavGroupId,
                        q: '',
                        num: 1000,
                        authentication: userSession
                    })];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.results];
            case 3:
                err_1 = _a.sent();
                throw err_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getMyFavItems = getMyFavItems;
var toggleShareWithMyFavGroup = function (itemId) { return __awaiter(void 0, void 0, void 0, function () {
    var myFavGroupId, userSession, options, isSharedWithMyFavGroup, response, _a, err_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                myFavGroupId = __1.defaultOptions.myFavGroupId, userSession = __1.defaultOptions.userSession;
                if (!userSession) {
                    throw {
                        error: 'need to sign in before toggle sharing item with my fav group'
                    };
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 8]);
                options = {
                    groupId: myFavGroupId,
                    id: itemId,
                    authentication: userSession
                };
                return [4 /*yield*/, (0, arcgis_rest_portal_1.isItemSharedWithGroup)(options)];
            case 2:
                isSharedWithMyFavGroup = _b.sent();
                if (!isSharedWithMyFavGroup) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, arcgis_rest_portal_1.unshareItemWithGroup)(options)];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, (0, arcgis_rest_portal_1.shareItemWithGroup)(options)];
            case 5:
                _a = _b.sent();
                _b.label = 6;
            case 6:
                response = _a;
                return [2 /*return*/, response];
            case 7:
                err_2 = _b.sent();
                throw err_2;
            case 8: return [2 /*return*/];
        }
    });
}); };
exports.toggleShareWithMyFavGroup = toggleShareWithMyFavGroup;
